module.exports = __webpack_public_path__ + "img/v4_assetReport_h.5cb102ad.png";